






import SmoothReflowMixin, { Options } from 'vue-smooth-reflow';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    mixins: [SmoothReflowMixin],
})
export default class SmoothReflow extends Vue {
    @Prop({ type: String, default: 'div' })
    private tag!: string;

    @Prop(Object)
    private options?: Options | Options[];

    protected mounted(): void {
        if (this.$smoothReflow === undefined) {
            return;
        }
        this.$smoothReflow(this.options);
    }
}
